import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from '../../app.constants';
import { User } from '../classes/user';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationService {
  LOGIN_URL = this._configuration.apiUrl + "/v2/login";
  // Number of seconds of inactivity before logout
  LOGOUT_TIMER: number = 300;

  logoutTimer: number;

  _h: Headers = new Headers();
  _u: User = new User();
  _logged_in: boolean = false;

  constructor(private _http: Http, private _configuration: Configuration, private router: Router) { }

  getUser() {
    return this._u;
  }

  setUser(user: User) {
    this._u = user;
  }

  getHeaders() {
    return this._h;
  }

  login(username: string, password: string) {
    this._h = new Headers();
    this._h.append('Authorization', 'Basic ' + btoa(username + ':' + password));

    //Disable for import
    //this.resetTimeout();

    return this.testLogin();
  }

  testLogin() {
    return this._http.get(this.LOGIN_URL, { headers: this._h }).map(response => response.json());
  }

  logout() {
    this._h = new Headers();
    this._u = new User();

    localStorage.clear();

    this._logged_in = false;

    //Disable for import
    //clearTimeout(this.logoutTimer);
  }

  setLoggedIn(status: boolean, user: User) {
    this._logged_in = status;
    this._u = user;
    // Store it for later
    localStorage.setItem('user', JSON.stringify(this._u));
    localStorage.setItem('authHeader', this._h.get('Authorization'));
  }


  isLoggedIn() {
    //Disable for import
    //this.resetTimeout();

    return this._logged_in;
  }

  resetLoggedIn(value: boolean) {
    this._logged_in = value;
  }

  resetTimeout() {
    clearTimeout(this.logoutTimer);
    // When logging out, flag it, go to login page and logout
    this.logoutTimer = setTimeout(() => {
      console.log('LOGOUT AFTER ' + this.LOGOUT_TIMER + ' seconds INACTIVITY', new Date());
      this.router.navigate(['/login']);
      this.logout();
    }, this.LOGOUT_TIMER * 1000);
  }

  retrievePreviousSession() {
    if (localStorage['user'] == null || localStorage['authHeader'] == null) return false;
    // Retrieve Info
    this._u = JSON.parse(localStorage.getItem('user'));

    this._h = new Headers();
    this._h.append('Authorization', localStorage['authHeader']);
  }

  getUsername() {
    return this._u.name;
  }

  getRole() {
    return this._u.role;
  }

  getFirstName() {
    return this._u.first_name
  }

  getLastName() {
    return this._u.last_name
  }

  getCpnCode() {
    return this._u.cpn_code
  }

  getUserRoles() {
    return this._u.module_roles
  }

  getPrinterId() {
    return this._u.printer_id
  }

  getCsvSeparator() {
    console.log(this._u.csv_separator);
    return this._u.csv_separator;

  }

  getUsableCsvSeparator() {
    if (this._u.csv_separator === 'comma') {
      console.log(',');
      return ',';
    } else if (this._u.csv_separator === 'semicolon') {
      console.log(';');
      return ';';
    } else {
      console.log('default ;');
      return ';';
    }
  }

  getUserBranches() {
    // Turn ID to numbers
    this._u.branch_list.forEach((b: any) => { b['id'] = Number.parseInt(b['id']) });

    return this._u.branch_list
  }

  getHomeBranch() {
    return this._u.branch_id
  }

  getRightLevel() {
    return this._u.right_level
  }

  getLanguage() {
    return this._u.language
  }

  // Check Rights
  isSuper() {
    return this._u.right_level == 'Senior';
  }

  isAdmin() {
    return this._u.right_level == 'Senior' || this._u.right_level == 'Admin';
  }

  isExecutive() {
    return this._u.right_level == 'Senior' || this._u.right_level == 'Admin' || this._u.right_level == 'Executive';
  }

  isViewer() {
    return this._u.right_level == 'Viewer';
  }

  // Check Roles
  hasRole(role: string) {
    return (this._u.module_roles || []).some(r => r.name == role);
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/services/authentication.service.ts